// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { TECMessagesModel } from "@store/Framework/Types/ApiModels";
import { GetTECMessagesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import TECMessagesState from "@store/Framework/Store/Greif/Data/TECMessages/TECMessagesState";
import { Draft } from "immer";

const initialState: TECMessagesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
};

const actions = {
    "Greif/Data/TECMessages/BeginLoadTECMessages": (
        draft: Draft<TECMessagesState>,
        action: { parameter: GetTECMessagesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/TECMessages/CompleteLoadTECMessages": (
        draft: Draft<TECMessagesState>,
        action: {
            parameter: GetTECMessagesApiParameter;
            collection: TECMessagesModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => Object(collection)!);

        if (draft.failedToLoadTECMessages) {
            draft.failedToLoadTECMessages = false;
        }
    },

    "Greif/Data/TECMessages/FailedToLoadTECMessages": (draft: Draft<TECMessagesState>) => {
        draft.failedToLoadTECMessages = true;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataTECMessagesActions = Parameters<typeof reducer>[1];
export default reducer;
